
import React, { useEffect, useRef, useState } from 'react';
import TapIcon from "../../../services/TapIcon";
import Status from '../../../components/ui/Status';
import HttpAPICall from '../../../services/HttpAPICall';
import { EMP_WORKLOG_URL, HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import DateService from '../../../services/DateService';
import AttendenceSummaryDetailModal from './AttendenceSummaryDetailModal';
import WorkLogDetailModal from './WorkLogDetailModal';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import WorkLogModal from './WorkLogModal';
import { DisplayListPagination } from '../../../components/TapUi';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import moment from 'moment';



const AttendenceSummary = ({ attendenceData, onClose ,onAttendanceRefresh }) => {
    const access_token = useSelector((state) => state.auth.access_token);
    const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);
    const worklogModalRef = useRef(null)
    const worklogEditModalRef = useRef(null)
    const history = useHistory()

    const [attendanceLoading, setAttendanceLoading] = useState(false);  
    const [worklogLoading, setWorkLogLoading] = useState(false); 
    const [attendanceDetails, setAttendanceDetails] = useState([]);
    const [workLogDetails, setWorkLogDetails] = useState([]);
    const [employeeLoading, setEmployeeLoading] = useState(false);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState(null);
      const [demandlistingMeta, setDemandlistingMeta]                           =    useState({})
    


    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        if (attendenceData?.employeeId) {
            loadAttendanceDetails(attendenceData);
            loadWorkLogData(attendenceData)
        }
        setEmployeeDetails(attendenceData?.employeeData)
    }, []);
    const employeeHandler = (data) => {

        const currentDate = attendenceData?.date || new Date();

        const currentMonth = moment(currentDate).format('YYYY-MM');

        history.push({
            pathname: `/employee_list/${data.enc_id}`,
            state: {
                monthly: true,
                month: currentMonth
            }
        });
    }
    const handleAttendenceSummary = (item) => {
        setSelectedAttendance(item);
        setShowDetails(true);
    }

    const loadAttendanceDetails = (attendenceData) => {
        setAttendanceLoading(true);
        HttpAPICall.withAthorization("GET", `${HRM_API_BASE_URL_2}/attendance_summary/${attendenceData?.employeeId}`,
            access_token, { date: attendenceData?.date }, {}, (resp) => {
                const respData = resp?.data;
                setAttendanceDetails(respData || "");
            }
        ).then(() => {
            setAttendanceLoading(false);
        });
    };

    const loadWorkLogData = (attendenceData , page = 1) => {
        setWorkLogLoading(true);
        const attendanceIds = attendenceData?.attendence?.map(item => item.id) || [];
        const params = {
            search_date: attendenceData?.date,
            search_employee_id: attendenceData?.employeeId,
            search_attendance_ids: attendanceIds,
            per_page: 10

        }
         if (page) {
            params.page = page;
        }
        HttpAPICall.withAthorization("GET", `${EMP_WORKLOG_URL}/list`,
            access_token, params, {}, (resp) => {
                const respData = resp?.data;
                setWorkLogDetails(respData?.data || "");
                setDemandlistingMeta({
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page,
                })
            }
        ).then(() => {
            setWorkLogLoading(false);
        });
    };

    const viewWorklogInit = (data) => {
        worklogModalRef.current.viewWorkLogDetailModalInit(employeeDetails, data);
    }
    const editWorklogInit = (employeeDetails, item) => {
        
        const data ={
            employee : employeeDetails,
            attendence : attendenceData?.attendence
        }
        worklogEditModalRef.current.worklogEditModalInit(data, item);
    }
 
    const worklogDeleteInit = (id) => {
        swal({
            title: "Delete WorkLog",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                setWorkLogLoading(true);
                HttpAPICall.withAthorization( 'DELETE', `${EMP_WORKLOG_URL}/delete/${id}`,access_token,
                    {}, {},(response) => {
                        toast.success(response.data.msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        loadWorkLogData(attendenceData);
                         if (onAttendanceRefresh) {
                            onAttendanceRefresh();
                        }
                    }
                ).then(() => {
                    // setWorkLogLoading(false);
                });
            }
        });
    }
    const attendenceSummaryDataJsx = () => {
        return (
            <div className="col-9 pageTbl pb-5 mb-5" >
                {attendanceLoading ? <Loader /> :
                    <>
                        <div className="tab_content_wrapper fw-bold my-2">Attendence Details</div>
                        <div className=' mx-3'>
                            
                                    <table className=" mt-3 table table-bordered table-hover">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th className='text-center' style={{ width: "20%" }}>Check-In </th>
                                                <th className='text-center' style={{ width: "20%" }}>Check-Out</th>
                                                <th className='text-center' style={{ width: "20%" }}>Status</th>
                                                <th className='text-center' style={{ width: "10%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {attendanceDetails && attendanceDetails.length > 0 ? attendanceDetails.map((item, index) => (
                                                <tr key={index}>
                                                    <td className='text-center'>{item?.check_in_minutes}
                                                        {item?.check_out_date && item?.check_in_date !== item?.check_out_date && (
                                                            <> <span className="text-muted">({item?.check_in_date})</span></>
                                                        )} </td>
                                                    <td className='text-center'> {item?.check_out_minutes}
                                                        {item?.check_out_date && item?.check_in_date !== item?.check_out_date && (
                                                            <> <span className="text-muted">({item?.check_out_date})</span></>
                                                        )}
                                                    </td>
                                                    <td className='text-center'>
                                                        {item?.status &&
                                                            <Status color={item.status.color_code}>
                                                                {item.status.name}
                                                            </Status>}
                                                    </td>

                                                    <td className='text-center link-primary cursor_pointer'
                                                        onClick={() => handleAttendenceSummary(item)}
                                                    >
                                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                                                    </td>

                                                </tr>
                                            ))
                                                : <tr>
                                                    <td className='text-center' colSpan={4}> No Record Found</td>
                                                </tr>}

                                        </tbody>
                                    </table>
                        </div>
                        {workLogDetails && workLogDetails.length > 0 && <>
                            <div className="tab_content_wrapper fw-bold my-2"> WorkLog</div>
                            <div className='mb-5 mx-3'>
                                {worklogLoading ? (
                                    <div className="text-center py-4">
                                        <Loader />
                                    </div>
                                ) : (
                                    <>
                                <table className=" mt-3 table table-bordered table-hover ">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th className='text-center' style={{ width: "20%" }}>Start Time </th>
                                            <th className='text-center' style={{ width: "20%" }}>End time</th>
                                            <th className='text-center' style={{ width: "20%" }}>WorkLog Type</th>
                                            <th className='text-center' style={{ width: "10%" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {workLogDetails && workLogDetails.length > 0 ? workLogDetails.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    {item?.start_time && (
                                                        <>
                                                            {DateService.dateTimeFormat(item.start_time, "hh:mm A")}
                                                            {item?.end_time &&
                                                                DateService.dateTimeFormat(item.start_time, "YYYY-MM-DD") !==
                                                                DateService.dateTimeFormat(item.end_time, "YYYY-MM-DD") && (
                                                                    <span className="text-muted">
                                                                        ({DateService.dateTimeFormat(item.start_time, "DD-MMM-YYYY")})
                                                                    </span>
                                                                )}
                                                        </>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {item?.end_time && (
                                                        <>
                                                            {DateService.dateTimeFormat(item.end_time, "hh:mm A")}
                                                            {item?.start_time &&
                                                                DateService.dateTimeFormat(item.start_time, "YYYY-MM-DD") !==
                                                                DateService.dateTimeFormat(item.end_time, "YYYY-MM-DD") && (
                                                                    <span className="text-muted">
                                                                        ({DateService.dateTimeFormat(item.end_time, "DD-MMM-YYYY")})
                                                                    </span>
                                                                )}
                                                        </>
                                                    )}
                                                </td>
                                                <td className='text-center'>
                                                    {item?.work_log_type && item?.work_log_type?.name}
                                                </td>

                                                <td className="text-center">
                                                    <button type="button" className="btn btn-light" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                                        <TapIcon.imageIcon icon={TapIcon.ListActionIcon} className="img-fluid" alt="item-action" />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end cursor_pointer">
                                                        <li>
                                                            <a role="button"
                                                                onClick={() => {
                                                                    if (!permissions.includes('worklog-view')) {
                                                                        return viewWorklogInit(item)
                                                                    }
                                                                }}
                                                                className={['dropdown-item', !permissions.includes('worklog-view') ? '' : 'disabled'].join(' ')}
                                                                title={!permissions.includes('worklog-view') ? 'You do not have permission to perform this action' : ''}
                                                                style={{ "pointerEvents": "all" }}
                                                            >View</a>
                                                        </li>
                                                        <li>
                                                            <a role="button"
                                                                onClick={() => {
                                                                    if (!permissions.includes('worklog-edit')) {
                                                                        return editWorklogInit(employeeDetails, item)
                                                                    }
                                                                }}
                                                                className={['dropdown-item', !permissions.includes('worklog-edit') ? '' : 'disabled'].join(' ')}
                                                                title={!permissions.includes('worklog-edit') ? 'You do not have permission to perform this action' : ''}
                                                                style={{ "pointerEvents": "all" }}
                                                            >Edit</a>
                                                        </li>
                                                        <li>
                                                            <a role="button"
                                                                onClick={() => {
                                                                    if (!permissions.includes('worklog-delete')) {
                                                                        return worklogDeleteInit(item.id)
                                                                    }
                                                                }}
                                                                className={['dropdown-item', !permissions.includes('worklog-delete') ? '' : 'disabled'].join(' ')}
                                                                title={!permissions.includes('worklog-delete') ? 'You do not have permission to perform this action' : ''}
                                                                style={{ "pointerEvents": "all" }}
                                                            >Delete</a>
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td className='text-center' colSpan={4}> No Record Found</td>
                                            </tr>}

                                    </tbody>
                                </table>
                               
                                {demandlistingMeta.last_page > 1 && (
                                    <DisplayListPagination
                                        meta={demandlistingMeta}
                                        onPageChange={(e) =>
                                            loadWorkLogData(attendenceData, e.selected + 1)
                                        }
                                    />
                                )}
                                 </> )}
                            </div>
                        </>}
                    </>
                }
            </div>
        );
    };

    const attendenceSummaryDataMinimizableJsx = () => {

        return (
            <div className="col-3 pageTbl pb-5">
                {attendanceLoading ? <Loader /> :
                    <table className="table table-bordered  bg-white table-sm">
                        <thead className="table-secondary">
                            <tr>
                                <th scope="col" style={{ width: "15%" }}>
                                    <div className="mt-1 d-flex align-items-center justify-content-between">
                                        <span className="text-capitalize ">
                                            Check-In
                                        </span>
                                        <span className="text-capitalize ">
                                            Check-Out
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            {attendanceDetails.map((item, index) => (
                                <tr key={index}>
                                    <>
                                        <td style={{ width: "25%" }}>
                                            <div className="mt-1 d-flex align-items-center justify-content-between">
                                                <small className="text-capitalize ">
                                                    {item?.check_in_date && DateService.dateFormat(item?.check_in_date)}
                                                    {item?.check_in_minutes}
                                                </small>
                                                <small className="text-capitalize ">
                                                    {item?.check_out_date && DateService.dateFormat(item?.check_out_date)}
                                                    {item?.check_out_minutes}
                                                </small>
                                            </div>
                                            <div className="mt-1 d-flex align-items-center justify-content-between">
                                                <small className="text-capitalize ">
                                                    {item?.status &&
                                                        <Status color={item.status.color_code}>
                                                            {item.status.name}
                                                        </Status>}
                                                </small>
                                                <span className="text-capitalize link-primary cursor_pointer"
                                                    onClick={() => handleAttendenceSummary(item)}
                                                >
                                                    view
                                                </span>
                                            </div>

                                        </td>
                                    </>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                }
            </div>
        );
    };
    const attendenceCardJsx = () => {

        return (

            <div className="col-3 border-end pageTbl">
                <div className="tab_content_wrapper fw-bold my-2">Employee Details</div>
                <div className="row py-2 border-top border-bottom">
                    <div className="col-6">Employee</div>
                    <div className="col-6 px-0 fw-bold"> <span className="cursor_pointer link-primary" onClick={() => employeeHandler(employeeDetails)}>{employeeDetails?.display_full_name}</span>
                    </div>
                </div>
                <div className="row py-2 border-top border-bottom">
                    <div className="col-6">Date</div>
                    <div className="col-6 px-0 fw-bold">{DateService.dateFormat(attendenceData?.date)}</div>
                </div>
                <div className="row py-2 border-top border-bottom">
                    <div className="col-6">Mobile</div>
                    <div className="col-6 px-0 fw-bold">{employeeDetails?.mobile}</div>
                </div>
                <div className="row py-2 border-top border-bottom">
                    <div className="col-6">Status</div>
                    <div className="col-6 px-0 fw-bold">{employeeDetails?.status && <Status color={employeeDetails.status_color_code}> {employeeDetails.status_text} </Status>}</div>
                </div>
            </div>
        );
    };

    return (
    <>
        <div className=" pl5 mt-1" style={{overflow : "hidden"}}>
            <div className="bg-white row p-2 text-decoration-none d-flex align-items-center justify-content-between">
                <div className="col-sm-5">
                    <h6>Attendance Summary ({DateService.dateFormat(attendenceData?.date)})</h6>
                </div>
              <div className="col-sm-5 text-end ">
                        {showDetails ? (
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary me-2"
                                onClick={() => setShowDetails(false)}
                            >
                              <TapIcon.imageIcon
                                icon={TapIcon.CloseIcon}
                                className="cursor_pointer img-fluid"
                                color="white"
                            />
                            </button>
                        ) : 

                        <button
                                type="button"
                                className="btn btn-sm btn-secondary ms-1"
                                onClick={onClose}
                                disabled={attendanceLoading || worklogLoading}
                            >
                                <TapIcon.imageIcon
                                    icon={TapIcon.CloseIcon}
                                    className="cursor_pointer img-fluid"
                                    color="white"
                            />
                        </button> }
                    </div>
            </div>
            <div className="row pl0 bg-white page_containt pe-3 ">
                {!showDetails ? (
                    employeeLoading ? (
                        <div className='col-9 bg-white pt-5 pl4 pr4'>
                            <Loader />
                        </div>
                    ) : (
                        attendenceCardJsx()
                    )
                ) : (
                    attendenceSummaryDataMinimizableJsx()
                )}

                {!showDetails ? (
                    attendenceSummaryDataJsx()
                ) : (
                    <>
                            <AttendenceSummaryDetailModal detailData={selectedAttendance} />
                    </>
                    )}
                </div>
                <WorkLogDetailModal ref={worklogModalRef} />
                <WorkLogModal ref={worklogEditModalRef} afterSucess={() => {
                    loadWorkLogData(attendenceData);
                }} />
        </div>
    </>
);
};

export default AttendenceSummary;